'use strict';

import main from './lib/seoUrl';

export default main;

